// ---------------------------------------------------------------------------
// A6: Workflow Folders
// ---------------------------------------------------------------------------
// Organizes workflows into folders for UI navigation.
// Simple parent-child (flat for now, no nesting).

import { pgTable, uuid, text, timestamp, index } from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

export const workflowFolders = pgTable(
  "workflow_folders",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    name: text("name").notNull(),
    description: text("description"),
    color: text("color"), // Hex color for UI badge
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_workflow_folders_tenant").on(table.tenantId),
  ],
);
